import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { noop } from 'lodash';
import socialNetworkNames, { shareMappingPath } from '../../../../constants/social-networks';
import { buildUrl } from '../../../../../common/utils/url/build-url';
import { getOrigin } from '../../../../../common/utils/url/get-origin';
import { getBsi } from '../utils';
import { openPopup } from '../../../../../common/utils/open-popup';
import Tooltip from '../../../../ui-components/tooltip/tooltip';
import InlineIcon from '../../../../ui-components/inline-icon/inline-icon';
import parentStyles from '../styles.scss';
import TwitterIcon from '../../../../../icons/compiled/components/TwitterIcon';
class Twitter extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", () => {
      const {
        instanceInfo,
        videoId,
        channelId,
        descriptionText,
        canShareContent,
        content
      } = this.props;
      const {
        instanceId,
        componentId,
        sitePageId,
        siteUrl,
        biToken
      } = instanceInfo;
      const baseUrl = getOrigin(siteUrl);
      const shareProxyUrl = buildUrl(baseUrl + "/" + shareMappingPath + "/" + sitePageId, {
        'instance-id': instanceId,
        'component-id': componentId,
        'channel-id': channelId,
        'video-id': videoId,
        'bi-token': biToken,
        bsi: getBsi()
      });
      if (canShareContent) {
        const url = buildUrl('https://twitter.com/intent/tweet', {
          // eslint-disable-next-line
          original_referer: siteUrl,
          text: descriptionText.replace('{siteUrl}', shareProxyUrl).replace('{title}', content.title)
        });
        openPopup(url);
      }
      this.props.onShare(socialNetworkNames.TWITTER);
    });
  }
  render() {
    const {
      className,
      dataHook,
      ariaLabel,
      tooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.onClick,
      "data-hook": dataHook,
      className: className,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(TwitterIcon, null),
      className: parentStyles.icon
    })));
  }
}
_defineProperty(Twitter, "defaultProps", {
  onShare: noop
});
export default Twitter;
//# sourceMappingURL=twitter.js.map